// ENDPOINTS
export const SERVER_URL = process.env.BACKEND_URL
export const LOGIN = `${SERVER_URL}/login`
export const LOGOUT = `${SERVER_URL}/logout`
export const REFRESH_TOKEN = `${SERVER_URL}/refreshToken?refreshToken=`
export const LOGIN_AZURE = `${SERVER_URL}/loginAzure`
export const LOGIN_CONFIG = `${SERVER_URL}/configs/login`
export const GET_USERS = `${SERVER_URL}/users`
export const SEARCH_USERS = `${SERVER_URL}/users/search`
export const GET_USERS_LOG = (query) => `${SERVER_URL}/auditLogs${query}`
export const GET_DEPTS = `${SERVER_URL}/departments`
export const GET_DEPTS_NON_SEGREGATE = `${SERVER_URL}/departments?nonSegregate=true`
export const GET_DEPTS_BY_COMPANY = (ids) =>
  `${SERVER_URL}/departments?${ids.map((d) => `companyIds[]=${d}`).join('&')}`
export const GET_COMPANIES = `${SERVER_URL}/companies`
export const GET_CONTRACTORS = `${SERVER_URL}/contractors`
export const GET_CONTRACTOR_CATEGORIES = `${SERVER_URL}/contractorCategories`
export const GET_CONFORMITY_CATEGORIES = `${SERVER_URL}/conformityCategoryCompanies`
export const GET_GROUPS = `${SERVER_URL}/groups`
export const GET_LOCATIONS = `${SERVER_URL}/locations`
export const GET_WORK_LOCATIONS = `${SERVER_URL}/workLocations`
export const GET_ROMS = `${SERVER_URL}/truckscale/roms`
export const DAILY_REPORT = `${SERVER_URL}/dailyReports`
export const BLAST_DAILY_REPORT = `${SERVER_URL}/dailyReports/blast`
export const GET_DAILY_LOADING_POINT = `${SERVER_URL}/dailyElevations/report`
export const DATA_VALIDATION = `${SERVER_URL}/dataValidations`
export const PERMISSIONS = (id = null) =>
  `${SERVER_URL}/permissions${id ? `/${id}` : ''}`
export const PIT_PLAN = (id, lastSyncDate) =>
  `${SERVER_URL}/locations/${id}/effectivePitPlan?lastSyncDate=${lastSyncDate}`
export const LOOKUP_TYPES = (type) => `${SERVER_URL}/lookup?type=${type}`
export const TASK_SUPPORT_REQUEST = `${SERVER_URL}/supportRequest`
export const TASK_CONFORMITY_REPORT = `${SERVER_URL}/conformityReport`
export const FORGOT_PASSWORD = `${SERVER_URL}/forgotPassword`
export const FORGOT_PASSWORD_VALIDATE = `${SERVER_URL}/forgotPassword/validate`
export const RESET_PASSWORD = `${SERVER_URL}/resetPassword`
export const VERIFY_TWOFA_CODE = `${SERVER_URL}/verify2facode`
export const RESEND_TWOFA_CODE = `${SERVER_URL}/resendverificationcode`
export const NOTIF_SELF = `${SERVER_URL}/notifications/self`
export const NOTIF = `${SERVER_URL}/notifications`
export const SEARCH_CC = (keyword, pitId) =>
  `${SERVER_URL}/notificationUsers?search=${keyword}&pitId=${pitId}`
export const USER_SELF = `${SERVER_URL}/users/self`
export const USER_LDAP = (username = '') =>
  `${SERVER_URL}/checkFromLDAP?username=${username}`
export const CONTRACTOR_PIT = `${SERVER_URL}/contractors?include=pit`
export const RAINFALL_VALIDATIONS = `${SERVER_URL}/rainfallValidations`
export const RIT_OB_VALIDATIONS = `${SERVER_URL}/ritOBValidations`
export const PUMPING_VALIDATIONS = `${SERVER_URL}/pumpingProgressValidations`
export const OUTPIT_RAINFALL_VALIDATIONS = `${SERVER_URL}/outpitRainfallValidations`
export const OUTPIT_WORK_VALIDATIONS = `${SERVER_URL}/outpitWorkValidations`
export const CHECKLIST = `${SERVER_URL}/checklist`
export const BARGE_LOADINGS_FINALIZE = `${SERVER_URL}/bargeLoadings/finalize`
export const BLASTING_REPORTS = `${SERVER_URL}/blastingReports`
export const BLASTING_REPORTS_ATTACHMENT = `${SERVER_URL}/blastingReports/attachment`
export const BLASTING_REPORTS_APPROVAL = `${SERVER_URL}/blastingReports/approval`
export const GET_COAL_PILE = `${SERVER_URL}/coalStockInventories/coalpiles`

// TASK MANAGEMENT & COLLAB
export const TASK = {
  SUPPORT_REQUEST: (id = null, isCollab = null) =>
    `${SERVER_URL}/supportRequest${id ? `/${id}` : ''}${
      isCollab ? `/collaboration` : ''
    }`,
  CONFORMITY_REPORT: (id = null, isCollab = null) =>
    `${SERVER_URL}/conformityReport${id ? `/${id}` : ''}${
      isCollab ? `/collaboration` : ''
    }`,
}

// TYPES
export const SUPPORT_REQUEST = 'SUPPORT_REQUEST'
export const CONFORMITY_REPORT = 'CONFORMITY_REPORT'
export const SUPPORT_REQUEST_COLLABORATION = 'SUPPORT_REQUEST_COLLABORATION'
export const CONFORMITY_REPORT_COLLABORATION = 'CONFORMITY_REPORT_COLLABORATION'
export const CONFORMITY_TYPE = 'CONFORMITY_TYPE'
export const CONFORMITY_DEPTS = 'CONFORMITY_DEPTS'
export const BARGE_CHECKLIST = 'BARGE_CHECKLIST'
// BARGE LOADING
export const BARGE_LOADING = 'BARGE_LOADING'
export const BARGE_LOADING_HEADER = 'BARGE_LOADING_HEADER'
export const BARGE_LOADING_FUEL_CONSUMPTION = 'BARGE_LOADING_FUEL_CONSUMPTION'
export const BARGE_LOADING_DRAFT_SURVEY = 'BARGE_LOADING_DRAFT_SURVEY'
export const BARGE_LOADING_BARGE_SURVEY = 'BARGE_LOADING_BARGE_SURVEY'
export const LOADING_REQUEST = `${SERVER_URL}/mercy/loadingRequests`
export const UNIT_DOZER_EXCAVATORS = `${SERVER_URL}/unitDozerExcavators`
export const TUNNELS = `${SERVER_URL}/mercy/tunnels`
export const BELT_SCALE = `${SERVER_URL}/mms/controlRooms`
// BLASTING REPORT
export const BLASTING_REPORT = 'BLASTING_REPORT'
export const BLASTING_REPORT_POSITION_TYPE_BEK =
  'BLASTING_REPORT_POSITION_TYPE_BEK'
export const BLASTING_REPORT_PIT_INFO = 'BLASTING_REPORT_PIT_INFO'
export const BLASTING_REPORT_GEOMETRY = 'BLASTING_REPORT_GEOMETRY'
export const BLASTING_REPORT_EXPLOSIVE = 'BLASTING_REPORT_EXPLOSIVE'
// STOCK OPNAME
export const GET_ROM_LOCATIONS = `${SERVER_URL}/romLocations`
export const COAl_STOCK_INVENTORIES = `${SERVER_URL}/coalStockInventories`
export const COAL_STOCK_FINALIZE = `${SERVER_URL}/coalStockInventories/finalize`
export const GET_AREAS = `${SERVER_URL}/dirAreas`
export const GET_DIR_LOCATIONS = `${SERVER_URL}/dirLocations`
export const GET_PRODUCTS = `${SERVER_URL}/products`
export const SYNC_MASTER_DATA = `${SERVER_URL}/sync/masterData`
export const PREVIEW_UPLOAD = `${SERVER_URL}/coalStockInventories/previewUpload`
export const UPLOAD_EXCEL = `${SERVER_URL}/coalStockInventories/upload`
export const DOWNLOAD_TEMPLATE = `${SERVER_URL}/coalStockInventories/downloadTemplate`
export const GET_VIEW_DETAIL = `${SERVER_URL}/coalStockInventories/byCompanyPeriod`
export const COAL_STOCK_UPLOAD_ATTACHMENT = `${SERVER_URL}/coalStockInventories/uploadAttachment`
export const COAL_STOCK_ATTACHMENT = `${SERVER_URL}/coalStockInventories/attachmentPeriods`

// DON'T DELETE - OBSOLETE LEGACY - JUST IN CASE NEEDED
// export const TASK_MANAGEMENT = `${SERVER_URL}/taskmanagement?type=`
// export const TASK_GET = (id, type) => `${SERVER_URL}/taskmanagement/${id}?type=${type}`
// export const COLLAB = {
//   SUPPORT_REQUEST: (id = null) => `${SERVER_URL}/supportRequest/collaboration${id ? `?id=${id}` : ''}`,
//   CONFORMITY_REPORT: (id = null) => `${SERVER_URL}/conformityReport/collaboration${id ? `?id=${id}` : ''}`
// }
// export const COLLAB_CLOSE = {
//   SUPPORT_REQUEST: `${SERVER_URL}/supportRequest/collaboration/close`,
//   CONFORMITY_REPORT: `${SERVER_URL}/conformityReport/collaboration/close`
// }
